import dayjs from 'dayjs';
import { UseFormReturn } from 'react-hook-form';
import { ControlledField, TimePickerInputField } from 'remote/global';

interface Props {
  formInstance: UseFormReturn<any>;
  name: string;
  translationKey?: string;
}

function TimePickerField(props: Props) {
  const { formInstance, name, ...rest } = props;
  const { control } = formInstance;

  return (
    <ControlledField
      control={control}
      name={name}
      render={(renderProps) => (
        <TimePickerInputField
          {...renderProps}
          fieldProps={{
            value: dayjs(renderProps.field.value as string, 'HH:mm:ss'),
            onChange: (value) =>
              renderProps.field.onChange(dayjs(value as unknown as string).format('HH:mm:ss')),
          }}
          {...rest}
        />
      )}
    />
  );
}

export default TimePickerField;
